/* global axios */
const DEFAULT_API_VERSION = 'v1';
const MULTIPART_HEADERS = {
  'Content-Type': 'multipart/form-data',
};

class BotifyAPI {
  constructor(resource, options = {}) {
    const { botifyUrl = '' } = window.chatwootConfig || {};
    this.botifyUrl = botifyUrl;
    this.apiVersion = `${botifyUrl}/api/${DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  // Returns a rejected Promise when botifyUrl is unset, null otherwise.
  // Usage: return this.ensureConfigured() || axios.get(…)
  ensureConfigured() {
    if (!this.botifyUrl) {
      return Promise.reject(
        new Error('[BotifyAPI] botifyUrl is not configured')
      );
    }
    return null;
  }

  get url() {
    if (!this.botifyUrl) return null;
    return `${this.baseUrl()}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl() {
    let url = `${this.apiVersion}/${this.resource}`;

    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}`;
    }

    return url;
  }

  get() {
    return this.ensureConfigured() || axios.get(`${this.url}/`);
  }

  show(id) {
    return this.ensureConfigured() || axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return this.ensureConfigured() || axios.post(`${this.url}/`, data);
  }

  create_multipart(data) {
    return (
      this.ensureConfigured() ||
      axios.post(`${this.url}/`, data, { headers: MULTIPART_HEADERS })
    );
  }

  create_workflow_form(data) {
    return this.ensureConfigured() || axios.post(`${this.url}`, data);
  }

  createForm(data) {
    return this.ensureConfigured() || axios.post(`${this.url}`, data);
  }

  update(id, data) {
    return this.ensureConfigured() || axios.patch(`${this.url}/${id}`, data);
  }

  update_multipart(id, data) {
    return (
      this.ensureConfigured() ||
      axios.patch(`${this.url}/${id}`, data, { headers: MULTIPART_HEADERS })
    );
  }

  delete(id) {
    return this.ensureConfigured() || axios.delete(`${this.url}/${id}`);
  }

  /**
   * Get corpus crawl status
   * @param {string} corpusId - The corpus ID
   * @returns {Promise} Response with crawl status
   */
  getCorpusCrawlStatus(corpusId) {
    return (
      this.ensureConfigured() ||
      axios.get(`${this.url}/crawl-status/${corpusId}`)
    );
  }

  newCreate(data) {
    return (
      this.ensureConfigured() ||
      axios.post(`${this.url}/new`, data, { headers: MULTIPART_HEADERS })
    );
  }

  newUpdate(id, data) {
    return (
      this.ensureConfigured() ||
      axios.patch(`${this.url}/${id}/new`, data, {
        headers: MULTIPART_HEADERS,
      })
    );
  }
}

export default BotifyAPI;
